import { request } from '@/libs/api-request'

export function getCurrentNext (params, force) {
  const url = '/ba/user_plan/get_current_next'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function checkBeforeUpdate (planUpdateTo, force) {
  const url = '/ba/user_plan/check_before_update'
  const params = {
    planUpdateTo
  }

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function updatePlan (params, force) {
  const url = '/ba/user_plan/update_plan'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function endInactivate (params, force) {
  const url = '/ba/user_plan/end_inactivate'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function cancelChange (params, force) {
  const url = '/ba/user_plan/cancel_change'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}

export function purchaseCreditTossWidget (payload, force) {
  const url = '/ba/credit/purchase_toss_widget'

  const config = {
    method: 'post',
    url,
    data: payload
  }
  return request(config, force)
}

export function purchaseCredit (payload, force) {
  const url = '/ba/credit/purchase'

  const config = {
    method: 'post',
    url,
    data: payload
  }
  return request(config, force)
}

export function applyFreePlan (force) {
  const url = '/ba/user_plan/apply_plan_check'

  const config = {
    method: 'post',
    url
  }
  return request(config, force)
}

export function contactUs (params, force) {
  const url = '/contact/'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, force)
}
